import { Drawer, Grid } from "antd";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { TopBar } from "@/components/layout/TopBar";

const { useBreakpoint } = Grid;

/**
 * Single tree across viewports so that crossing the `lg` breakpoint on
 * resize does NOT remount the `<main>` children. Previously this
 * component branched on `isDesktop` and returned two completely
 * different JSX trees — every child page reset its local state when the
 * user resized the window across 1024 px. Now we render one shell and
 * toggle the sidebar surface (inline rail vs. drawer) inside it.
 */
export function AppLayout({ children, noPadding }: { children: React.ReactNode; noPadding?: boolean }) {
  const screens = useBreakpoint();
  const isDesktop = screens.lg;
  const { pathname } = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="app-shell flex min-w-0 flex-col bg-surface-layout">
      <TopBar onMenuClick={isDesktop ? undefined : () => setDrawerOpen(true)} />
      {!isDesktop && (
        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          placement="left"
          styles={{
            wrapper: { width: 256 },
            body: { padding: 0, background: "var(--color-surface-sidebar)" },
            header: { display: "none" },
          }}
          style={{ padding: 0 }}
        >
          <Sidebar pathname={pathname} onNavigate={() => setDrawerOpen(false)} />
        </Drawer>
      )}
      <div className="flex min-h-0 min-w-0 flex-1 overflow-hidden">
        {isDesktop && (
          <div className="w-60 shrink-0 overflow-y-auto border-r border-border">
            <Sidebar pathname={pathname} />
          </div>
        )}
        <main
          className={
            noPadding
              ? "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden"
              : "app-content min-h-0 min-w-0 flex-1 overflow-y-auto"
          }
        >
          {children}
        </main>
      </div>
    </div>
  );
}
